import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { CustomFilterService } from 'path-shared/services/datasource/custom-filter-service';
import { SeguretatGrupsFilter } from '../models/seguretat-grups-filter';


const defaultSortParam = 'codiGrup';
const defaultSortDirection = 'asc';

@Injectable()
export class SeguretatGrupsFilterService extends CustomFilterService {
  public createFilterParams(filter: SeguretatGrupsFilter, start: number, pageSize: number, sortField: string, sortDir: string ) {

    return new HttpParams()
    .append('codiGrup', (filter.codiGrup ? filter.codiGrup.toString() : ''))
    .append('start', start.toString())
    .append('size', pageSize.toString())
    .append('sortparam', sortField === undefined ? defaultSortParam : sortField)
    .append('sortdir', sortDir === '' ? defaultSortDirection : sortDir);
  }
}
